module.exports = __webpack_public_path__ + "static/media/C5.6795a8f0.jpg";